import InternalLinksContainer from './internalLinksContainer';
export default InternalLinksContainer;
export type { LinkDataType } from './internalLinksContainer';